module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/premier_tablet-d53aba64fe6d41617d4149285aeeaca0.jpg";